export default __webpack_public_path__ + "static/media/move.e08d1892.svg";